import { Button } from 'components/atoms'
import I18n from 'core/i18n'
import * as React from 'react'
import styled, { AnyStyledComponent } from 'styled-components'
import * as constants from '../../../../static/constants'
import { BlockedTimeZone } from '../guide_assigns'

interface ISelectConversationGuideProps {
  guide: any
  calender: any
  hasConversation: boolean
  addGuide: (guide: any) => void
  preAssigned: BlockedTimeZone
  conflicted: boolean
}

const SelectConversationGuide: React.FC<ISelectConversationGuideProps> = ({
  guide,
  calender,
  hasConversation,
  addGuide,
  preAssigned,
  conflicted,
}) => {
  const getTimeZoneLabel = (isBlocked: boolean | null, stateLabel: string) => {
    if (!isBlocked) {
      return <span>{stateLabel}</span>
    }
    return <div className="pre_assign">{I18n.t('generic.pre_assigned')}</div>
  }

  return (
    <S.SelectConversationGuide isModal={true}>
      <S.GuideBadge>
        <div className="profile w65">
          <img src={guide.avatar_url} />
          <span className="userName">{guide.fullname}</span>
        </div>
        {!hasConversation && (
          <Button primary={true} handleClick={() => addGuide(guide)}>
            Chat
          </Button>
        )}
      </S.GuideBadge>
      <S.GuideInfo>
        <div className="info">
          <span>{I18n.t('calendar.am')}:</span>
          {getTimeZoneLabel(
            preAssigned?.am,
            constants.GUIDE_CALENDAR_MARK[calender.am].label || ''
          )}
        </div>
        <div className="info">
          <span>{I18n.t('calendar.pm')}:</span>
          {getTimeZoneLabel(
            preAssigned?.pm,
            constants.GUIDE_CALENDAR_MARK[calender.pm].label || ''
          )}
        </div>
        <div className="info">
          <span>{I18n.t('generic.comment')}:</span>
          <span>{calender.memo}</span>
        </div>
        <div className="info">
          {`${I18n.t('conversation.conflict')}: ${
            conflicted ? I18n.t('conversation.yes_conflict') : I18n.t('conversation.no_conflict')
          }`}
        </div>
      </S.GuideInfo>
    </S.SelectConversationGuide>
  )
}
const S: { [key: string]: AnyStyledComponent } = {}

S.SelectConversationGuide = styled.div<{ isModal?: false }>`
  width: calc(30% - 25px);
  min-width: 220px;
  max-width: 380px;
  margin-bottom: ${({ isModal }) => (isModal ? '36px' : '26px')};
  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    margin: 0 0 16px;
    width: 100%;
  }
`

S.GuideInfo = styled.div`
  padding: 8px;
  span {
    margin-right: 1em;
  }
  .info {
    margin: 2px 0;
  }
  .pre_assign {
    color: ${constants.COLORS.white};
    padding: 2px 12px;
    border-radius: 4px;
    background-color: ${constants.COLORS.caution};
    display: inline-block;
  }
`
S.GuideBadge = styled.div<{ selected?: false }>`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 8px;
  border-radius: 12px;
  background-color: ${({ selected }) =>
    selected ? constants.COLORS.secondary : constants.COLORS.divider};
  color: ${({ selected }) =>
    selected ? `${constants.COLORS.white}` : `${constants.COLORS.black}`};
  width: 100%;

  @media (max-width: ${constants.BREAKPOINT_TABLET_MOBILE}px) {
    width: 95%;
  }
  .w65 {
    max-width: 65%;
  }
  .w40 {
    max-width: 40%;
  }
  .profile {
    display: inline-flex;
    align-items: center;
    img {
      object-fit: cover;
      width: 24px;
      min-width: 24px;
      height: 24px;
      border-radius: 12px;
      margin-right: 8px;
    }
    .userName {
      text-overflow: ellipsis;
      overflow: hidden;
      margin-right: 8px;
    }

    .type {
      border-radius: 12px;
      color: ${constants.COLORS.white};
      padding: 2px 12px;
      background-color: ${constants.COLORS.primary};
      margin-right: 8px;
    }
  }
  .assigned {
    position: absolute;
    top: -20px;
    right: -10px;
    color: ${constants.COLORS.white};
    padding: 2px 12px;
    border-radius: 4px;
    background-color: ${constants.COLORS.caution};
  }
`
export default SelectConversationGuide
